module.exports = "../images/house-keeping-package@2x.jpg?v=3d2aa78";